import { isPrimeIconClass, primeIcon } from "../icon";
import { STATE_MESSAGE_ICONS } from "./state-message.constants";
import type { StateMessageProps, StateMessageViewModel } from "./types-state-message";

/** ViewModel do StateMessage: ícone e papel ARIA por variante; sem JSX. */
export function useStateMessage({
  variant,
  title,
  description,
  icon,
  action,
  inline,
  testId,
  className,
  style,
  classNames,
  ...rest
}: StateMessageProps): StateMessageViewModel {
  const showLoading = variant === "loading" && !icon;
  const resolved = icon ?? (variant === "loading" ? undefined : STATE_MESSAGE_ICONS[variant]);
  return {
    variant,
    title,
    description,
    icon,
    action,
    inline,
    testId,
    className,
    style,
    classNames,
    rest,
    showLoading,
    iconName: resolved && !isPrimeIconClass(resolved) ? resolved : null,
    iconClass: resolved && isPrimeIconClass(resolved) ? resolved : "",
    ariaLive: variant === "loading" ? "polite" : undefined,
    dataInline: inline || undefined,
    actionIcon: action?.icon ? primeIcon(action.icon, 14) : undefined,
    role: variant === "error" ? "alert" : "status",
    partTestId: (part: string) => (testId ? `${testId}-${part}` : undefined),
  };
}
